const orderedLists = document.querySelectorAll(".blog-wrap [start]");

if (orderedLists) {
  for (const ol of orderedLists) {
    let startValue = ol.getAttribute("start");
    let olValue = startValue - 1;
    ol.style.counterReset = `custom  ${olValue}`;
  }
}
